export default [
  {
    path: 'afiliados/contratos',
    name: 'contratos',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Contratos',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Contratos' }
      ]
    }
  }
]